"use client"

import React from "react"

import { cn, isDownloadLink, transformButtonStyle } from "@/lib/utils"
import { Link, TButton } from "@/components/ui/atoms"

type TButtonResolverProps = {
  data: TButton
  analyticsTitle?: string
  alignRight?: boolean
}

const ButtonResolver = ({
  data,
  analyticsTitle,
  alignRight,
}: TButtonResolverProps) => {
  if (!data) {
    return null // We can't render anything without data
  }

  let { ctaLabel, ctaLink, linkedPage, iconRight, iconLeft, style, codename } =
    data
  let link = ctaLink
  let target = "_self"
  if (linkedPage) {
    link = `/${linkedPage.path}`
  }
  if (ctaLink) {
    target = "_blank"
  }

  if (!link) {
    return
  }

  // Check if it's download link
  const isDownload = isDownloadLink(link)
  const navigationType = isDownload ? "download" : undefined

  return (
    <div
      className={cn("button-container flex", alignRight ? "justify-end" : null)}
    >
      <Link
        chapters={[analyticsTitle, ctaLabel]}
        variant={transformButtonStyle(style)}
        iconLeft={iconLeft ?? undefined}
        iconRight={iconRight ?? undefined}
        href={link}
        navigationType={navigationType}
        id={codename}
        target={target}
      >
        {ctaLabel}
      </Link>
    </div>
  )
}

export { ButtonResolver, type TButtonResolverProps }
